import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ClinicalIndustry from "@/pages/ClinicalIndustry";

export const Route = createFileRoute("/es/servicios/clinical-solutions/ensayos-clinicos-de-dispositivos-medicos")({
  head: () => buildRouteHead("/es/servicios/clinical-solutions/ensayos-clinicos-de-dispositivos-medicos"),
  component: ClinicalIndustry,
});

